import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, BoxProps, chakra, Flex, Heading, HeadingProps, Separator, Stack, Text, TextProps, VStack } from '@chakra-ui/react';
import { AppPanelToggleButton } from '@src/components/sco/AppLayout/Panel/AppPanelToggleButton';
import { MasonryGridBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/MasonryGridBlock';
import { RequestRoadmap } from '@src/components/sco/RequestRoadmap';
import { RequestsLayout } from '@src/components/sco/Requests/Layout/RequestsLayout';
import { RequestLPCardScroll } from '@src/components/sco/Requests/RequestsLP/RequestLPCardScroll';
import { RequestLPMyRequestsGrid } from '@src/components/sco/Requests/RequestsLP/RequestLPMyRequestsGrid';
import { SignupRequestBuilder } from '@src/components/sco/Requests/SignupRequestBuilder';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
import { usePathname } from 'next/navigation';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
const CURRENT_USER_GROUP_REQUESTS = gql`
  query {
    currentUser {
      id
      userId
      groupRequests {
        id
        pagination {
          itemCount
        }
      }
    }
  }
`;
export default function RequestsLandingPage() {
  const $ = _c(25);
  const pathname = usePathname();
  const activeContentContext = useActiveContentContext();
  const {
    data: currentUserData
  } = useQuery(CURRENT_USER_GROUP_REQUESTS);
  const hasMyRequests = (currentUserData?.currentUser?.groupRequests?.pagination?.itemCount ?? 0) > 0;
  let t0;
  if ($[0] !== activeContentContext) {
    t0 = () => {
      activeContentContext.setSiteSection("home.landing");
    };
    $[0] = activeContentContext;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useUniversalEffect(t0, t1);
  let t2;
  if ($[3] !== pathname) {
    t2 = pathname !== "/" && <Box marginBottom="-3em" paddingLeft={4} paddingTop={4} width="full"><AppPanelToggleButton panelId="requests-nav" /></Box>;
    $[3] = pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      children: <>{"Tell us your goal. "}{t3}<chakra.span {...{
          backgroundImage: "linear-gradient(90deg, #d97258 0%, #9858a3 100%)",
          backgroundClip: "text",
          color: "transparent"
        }}>We'll show you how to get there.</chakra.span></>
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = pathname == "/" ? "home" : "requests-landing";
  let t6;
  if ($[7] !== t5) {
    t6 = <SignupRequestBuilder funnelIdentifier={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RequestLPMyRequestsGrid />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <Block headingProps={t4}>{t6}{t7}</Block>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator width="full" />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== hasMyRequests) {
    t10 = !hasMyRequests && <Block background="colorPalette.panel" headingProps={{
      children: "Latest Startup Requests"
    }}><RequestLPCardScroll /></Block>;
    $[13] = hasMyRequests;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Separator width="full" />;
    t12 = <RequestRoadmap />;
    t13 = <Separator width="full" />;
    t14 = <MasonryGridBlock background="colorPalette.panel" />;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t10) {
    t15 = <Flex align="center" justify="center" width="full"><Stack align="center" gap={0} width="full">{t10}{t11}{t12}{t13}{t14}</Stack></Flex>;
    $[19] = t10;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t15 || $[22] !== t2 || $[23] !== t8) {
    t16 = <Box><RequestsLayout navPanelOpen={false} mainPanel={<VStack align="center" gap={0} width="full">{t2}{t8}{t9}{t15}</VStack>} /></Box>;
    $[21] = t15;
    $[22] = t2;
    $[23] = t8;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  return t16;
}
const Block = props => {
  const $ = _c(25);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = props.background || "transparent";
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([12, 12, 14, 14, 20]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([12, 12, 14, 14, 20]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = props.boxProps;
  const t4 = props.innerBoxProps;
  let t5;
  if ($[4] !== getBreakpointValue || $[5] !== props.children || $[6] !== props.headingProps || $[7] !== props.textProps) {
    t5 = (props.headingProps || props.textProps) && <VStack align="center" gap={getBreakpointValue([2, 2, 4])} marginBottom={props.children && getBreakpointValue([6, 6, 8, 10, 12])} paddingX={getBreakpointValue([4, 6, 8])} textAlign="center" width="full">{props.headingProps && <Heading as="h3" size={getBreakpointValue(["2xl", "3xl", "4xl", "4xl", "5xl"])} textAlign="center" {...props.headingProps} />}{props.textProps && <Text fontSize={getBreakpointValue(["lg", "lg", "xl", "xl", "2xl"])} maxWidth="container.lg" {...props.textProps} />}</VStack>;
    $[4] = getBreakpointValue;
    $[5] = props.children;
    $[6] = props.headingProps;
    $[7] = props.textProps;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getBreakpointValue) {
    t6 = getBreakpointValue([2, 2, 8]);
    $[9] = getBreakpointValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props.childBoxProps || $[12] !== props.children || $[13] !== t6) {
    t7 = <Box paddingX={t6} {...props.childBoxProps}>{props.children}</Box>;
    $[11] = props.childBoxProps;
    $[12] = props.children;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props.innerBoxProps || $[16] !== t5 || $[17] !== t7) {
    t8 = <Box marginX="auto" maxWidth="container.xl" {...t4}>{t5}{t7}</Box>;
    $[15] = props.innerBoxProps;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== props.boxProps || $[20] !== t0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t8) {
    t9 = <Box background={t0} gap={0} paddingBottom={t1} paddingTop={t2} width="full" {...t3}>{t8}</Box>;
    $[19] = props.boxProps;
    $[20] = t0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};